<script setup>
import { ref, computed,watch } from 'vue';
import { useQuasar,QVideo } from 'quasar';
const $q = useQuasar();
const isLargeScreen = computed(() => $q.screen.gt.xs);
const videoVisible = ref(false);

const darkMode = ref($q.dark.isActive);

watch(() => $q.dark.isActive, (newVal) => {
  darkMode.value = newVal;
})


useHead({
  title: 'About Us',
  meta: [
    { name: 'description', content: 'About OnSight Optical' }
  ]
})
</script>

<template>
  <div class="row justify-center q-mt-lg q-mb-lg" style="margin-top: 40px;">
    <div class="col-11 col-md-6">
      <div>
        <div class="q-pa-md">
          <q-video :ratio="16 / 9" src="https://www.youtube.com/embed/_mHP8DAYvAU?si=11CmpPQlzxcOIk09&rel=0&loop=1"/>
        </div>
      </div>
      <q-card :class="darkMode ? 'bg-grey-8 text-grey-4' : 'bg-brand text-white'" :style="{ borderRadius: '15px' }">
        <q-card-section>
          <div class="text-h3 text-center">About</div>
          <div class="text-h6 text-center">&nbsp;</div>
        </q-card-section>
        <q-card-section class="q-pt-none q-mt-auto" style="padding-left: 20px; padding-right: 20px;">
          <p style="font-size: 20px;">
            Michael Shane formed OnSight Optical, Inc. on March 15, 1995. The concept
            was developed to fill an optical dispensing need within ophthalmology practices. As OnSight Optical
            continues to grow, we remain dedicated to the goals established in 1995 while being forward thinking
            and using technological advancements. Our number one objective is to be a patient advocate. We have
            found that greater patient satisfaction will turn into referrals for your practice. OnSight Optical
            partners with optical dispensaries located in the highlighted states below. We establish a turnkey
            optical set up and complement each and every practice with a strong, hardworking staff that fits the
            practices' current needs. The partnered practices consist of private practice (adults, pediatrics
            or both), hospital setting, university setting or surgery center. OnSight Optical's support team
            consists of 100 years of combined experience in the optical world.
          </p>
        </q-card-section>
      </q-card>
    </div>
  </div>

  <div class="row justify-center q-mt-lg q-mb-lg">
    <div class="col-11 col-md-6">
      <q-img :src="darkMode ? '/img/StoreMapDark.jpg' : '/img/StoreMap.jpg'" alt="Frames" :style="{ borderRadius: '15px' }" />
    </div>
  </div>
</template>

